import { isTraumaCourseId } from "./ids";

export type TraumaOffer = { canBuy: boolean; price_usd: number | null };

export function traumaAccessActions(canOpen: boolean, single?: TraumaOffer, bundle?: TraumaOffer) {
  if (canOpen) return { start: true, single: false, bundle: false };
  return { start: false, single: single?.canBuy === true, bundle: bundle?.canBuy === true };
}

export function traumaBuyDestination(slug: string, hasProduct: boolean) {
  if (hasProduct) return null;
  const id = slug.startsWith("trauma-") ? slug.slice(7) : "";
  return isTraumaCourseId(id) ? { kind: "course" as const, id } : { kind: "catalog" as const };
}

export function traumaOwnedState(alreadyOwned: boolean, alreadyGranted: boolean) {
  return alreadyOwned || alreadyGranted;
}